import React, {useEffect, useState} from "react";

import EsketT from "./esketT";
import {useDom} from "../context/dom";
import {Spinner} from "reactstrap";
import {useParams} from "react-router-dom";


const CanvL = (pro) => {
const dom = useDom();
  const [ready, setReady] = useState(null);
  const data = useParams();
  useEffect(() => {

      const htmlCanvasElement = document.createElement("canvas");
      const rootElement = document.getElementById("ttid");
      htmlCanvasElement.width = window.innerWidth;
      htmlCanvasElement.height = window.innerHeight;
      htmlCanvasElement.id='foo';
      rootElement.prepend(htmlCanvasElement);


    return () => {
      console.log('og');
      //cancelAnimationFrame(requestRef.current);
    }

    /* //  */
    //   rafId.current = requestAnimationFrame(drawFrame)
  }, []);


  return (
    <>
      {
        dom.ck ? (
<>
           <EsketT prop={dom.ck} loc={data.location} pro={pro.user}/>

        </>
        ) : (
          <div className="flex" style={{height:'100vh',width:'100%',alignItems: 'center',
            justifyContent: 'center'}}>
          <Spinner   children={''}
                     style={{
                       height: '8rem',
                       width: '8rem'
                     }}
                     color="primary"
          >
          </Spinner>
</div>
        )


      }

    </>


  );
}
export default CanvL;
